import React, { useEffect, useState } from "react";
import bookLoader from "../assets/lotties/BookLoader.json";
import Lottie from "react-lottie";
import "../styles/bookLoader.css"

const loadingLottiFile = {
  loop: true,
  autoplay: true,
  animationData: bookLoader,
};

const phrases = ["Generating Requirements...", "Curating skills...", "Searching for responsibilities...", "Creating Content", "Finalising JD..."];

function BookLoader() {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [typingComplete, setTypingComplete] = useState(false);
  const letters = phrases[currentPhraseIndex].split("");

  useEffect(() => {
    // Start the typing animation for each new phrase
    setTypingComplete(false);

    const typeDuration = letters.length * 100; // 0.1s per letter
    const totalDuration = typeDuration + 2000; // Add 2 seconds pause after typing

    const timer = setTimeout(() => {
      setTypingComplete(true);
    }, typeDuration);

    const phraseChangeTimer = setTimeout(() => {
      setCurrentPhraseIndex((prevIndex) =>
        prevIndex === phrases.length - 1 ? 0 : prevIndex + 1
      );
    }, totalDuration);

    // Cleanup timers
    return () => {
      clearTimeout(timer);
      clearTimeout(phraseChangeTimer);
    };
  }, [currentPhraseIndex]);

  return (
    <div id="overlayAllJd">
      <div id="loaderPos">
        <Lottie height={150} width={150} options={loadingLottiFile} />
        <div className="flex space-x-[0.18rem] text-[1.2rem] font-semibold text-white">
          {letters.map((letter, index) => (
            <span
              key={index}
              className={`typing-effect ${!typingComplete ? 'opacity-100' : 'opacity-0'}`}
              style={{
                animationDelay: `${index * 0.1}s`,
                animationName: !typingComplete ? 'typing' : '',
              }}
            >
              {letter === " " ? "\u00A0" : letter}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BookLoader;